"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Converts an array of Contentful Entries using a map of factory functions
 *
 * @param {object} map - A map of allowed content modules and their factory functions
 * @param {array<object>} modules - An array of Contentful Entries
 * @returns {array<object>} - The transformed Contentful Entries
 */
var moduleMapper = function moduleMapper(map, modules) {
  var allModules = modules.map(function (module) {
    var _module$sys, _module$sys$contentTy, _module$sys$contentTy2;
    var contentType = module === null || module === void 0 ? void 0 : (_module$sys = module.sys) === null || _module$sys === void 0 ? void 0 : (_module$sys$contentTy = _module$sys.contentType) === null || _module$sys$contentTy === void 0 ? void 0 : (_module$sys$contentTy2 = _module$sys$contentTy.sys) === null || _module$sys$contentTy2 === void 0 ? void 0 : _module$sys$contentTy2.id;
    var factory = map[contentType];
    return factory ? factory(module) : null;
  });
  return allModules.filter(function (module) {
    return module !== null;
  });
};
var _default = moduleMapper;
exports["default"] = _default;